import { render, staticRenderFns } from "./FaqCategoryEditModal.vue?vue&type=template&id=7b1a33b6&"
import script from "./FaqCategoryEditModal.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports